export const getInitialMultiCollectionItemData = () => ({
  caption: '',
  collection: null,
})
